import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./screen/Home";
import { useUserTracking } from "./utils/useUserTracking";
import { useEffect } from "react";
import posthog from "posthog-js";

const App = () => {
  useEffect(() => {
    posthog.reset();
    // if (posthog.get_distinct_id()) posthog.identify(posthog.get_distinct_id());
  }, []);

  useUserTracking();

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
};

export default App;
